import React from 'react'
import { Link } from 'react-router'

const Thanks = () => {
  return (
    <div className="min-h-screen bg-primario text-secundario flex items-center justify-center px-4 py-16 font-secundaria">
      <section className="w-full max-w-4xl rounded-2xl border border-secundario/20 bg-primario/60 backdrop-blur-sm shadow-xl p-6 sm:p-10">
        {/* Icon */}
        <div className="mx-auto h-16 w-16 rounded-full border border-secundario/30 flex items-center justify-center">
          <svg
            className="h-8 w-8 text-secundario"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <path d="M22 4 12 14.01l-3-3" />
          </svg>
        </div>

        {/* Heading */}
        <h1 className="mt-6 text-center text-3xl sm:text-4xl md:text-6xl font-extrabold font-primaria">
          Thanks for your request!
        </h1>
        <p className="mt-3 text-center text-base sm:text-lg text-secundario/90 max-w-2xl mx-auto">
          We’ve received your submission. Our team will review your details and
          reach out shortly with next steps.
        </p>

        {/* What happens next */}
        <div className="mt-8 grid gap-6 sm:grid-cols-2">
          <div className="rounded-xl border border-secundario/15 p-5">
            <h2 className="text-xl font-semibold">What happens next</h2>
            <ul className="mt-3 space-y-2 text-secundario/90 list-disc list-inside">
              <li>We’ll confirm your request within 24–48 hours.</li>
              <li>Please check your inbox and spam folder.</li>
              <li>You can resubmit the form if you need to update details.</li>
            </ul>
          </div>

          <div className="rounded-xl border border-secundario/15 p-5">
            <h2 className="text-xl font-semibold">Need assistance?</h2>
            <p className="mt-3 text-secundario/90">
              If you have any urgent questions, feel free to contact us from the
              Services page or return to the homepage to keep exploring.
            </p>
          </div>
        </div>

        {/* CTAs */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-3 rounded-xl bg-secundario text-primario font-semibold hover:opacity-90 transition"
          >
            Go to Homepage
          </Link>
          <Link
            to="/services"
            className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-3 rounded-xl border border-secundario/40 text-secundario hover:bg-secundario/10 transition"
          >
            Explore Services
          </Link>
        </div>

      </section>
    </div>
  )
}

export default Thanks